export default "__VITE_ASSET__BM6rV2s___"